// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b15adbc","239":"32d107e4","455":"3025a9a5","750":"8deb4116","762":"5bd700c9"}[chunkId] + ".chunk.js";
};